import { routes } from "./next-routes"

// @ts-ignore
export const defaultRoutes = routes()
    .add("/", "index")
    .add("/index.html", "index")
    .add("/privacy-policy", "privacyPolicy")
    .add("/terms-of-service", "termsOfService")

    .add("/verify-email/:email/:code", "cognitoVerifyEmail")
    .add("/reset-password/:email/:code", "cognitoResetPassword")

    .add("/:accountSlug", "locationSelect")
    .add("/:accountSlug/:locationSlug", "main")
    .add("/:accountSlug/:locationSlug/:tab(info|orders|cart|profile|payments|addresses)", "main")
    .add("/:accountSlug/:locationSlug/:tab(cart)/:paymentStep(payment-option)/:selectedDeliveryType", "main")
    .add("/:accountSlug/:locationSlug/:tab(cart)/:paymentStep(finished)", "main")
    .add("/:accountSlug/:locationSlug/:tab(cart)/edit/:cartItemId", "main")
    .add("/:accountSlug/:locationSlug/:tab(login)", "main")
    .add("/:accountSlug/:locationSlug/:tab(login)/:authStep", "main")
    .add("/:accountSlug/:locationSlug/:tab(orders)/:orderId", "main")
    .add("/:accountSlug/:locationSlug/:categorySlug", "main")
    .add("/:accountSlug/:locationSlug/:categorySlug/:productSlug", "main")
